import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.schreibe-scannerlog';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungSchreibeScannerlogEffects {

    SchreibeScannerlog$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_SCHREIBE_SCANNERLOG),
        mergeMap((x: ac.PostSchreibeScannerlogAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postSchreibeScannerlog(x.scannerlogRequest).pipe(
                map((result: any) => {
                    return new ac.PostSchreibeScannerlogErfolgreichAction(x.scannerlogRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostSchreibeScannerlogFehlerAction(error, x.scannerlogRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungCommandService);
        }
        return this.service;
    }
}
